/* ---------------------------------------------------------------------------
   THE BUILD & DISCOVER COLLECTION — the six books every customer receives.

   This is the new primary library and is deliberately separate from the older
   data/books.ts, which still powers the original twelve-book collection and
   its search inside "Extra resources & previous library".

   Every id below is a verified, publicly readable Drive file.
--------------------------------------------------------------------------- */

export interface LibraryBook {
  n: number
  title: string
  fileId: string
  pages: number
  projects: number
  blurb: string
}

export const LIBRARY_FOLDER =
  'https://drive.google.com/drive/folders/100E_M4m6wHQA4ZUURUatdFGfxOzg_4yO'

export const libraryBooks: LibraryBook[] = [
  {
    n: 1,
    title: 'My First Builds',
    fileId: '1zt2KlWqGyPWHT0kF3JTa6GYu1PPkPZcm',
    pages: 67,
    projects: 20,
    blurb: 'The starting point. Short builds with everyday materials and plenty of room to get it wrong the first time.',
  },
  {
    n: 2,
    title: 'Wheels & Motion',
    fileId: '1l0q6Wdj47-7KjRLunOm_q40B28WrZiZY',
    pages: 67,
    projects: 20,
    blurb: 'Axles, rollers and ramps. Things that move, and what happens when you change one part of them.',
  },
  {
    n: 3,
    title: 'Bridges & Structures',
    fileId: '1q7jgS5DX2LsiQEUHfnT3vk2xCitJvEba',
    pages: 107,
    projects: 20,
    blurb: 'Spans, towers and frames built from paper and card, then tested until they finally hold.',
  },
  {
    n: 4,
    title: 'Machines & Mechanisms',
    fileId: '1R3VHIH1A5Uk9OEkClD-HH0U1VlYU-T3a',
    pages: 107,
    projects: 20,
    blurb: 'Levers, pulleys, gears and linkages, taken one simple mechanism at a time.',
  },
  {
    n: 5,
    title: 'Science You Can Build',
    fileId: '1IbYFXqusbIuIs-Nc-Emmhf3z0r24OA_4',
    pages: 107,
    projects: 20,
    blurb: 'Builds that show an idea working: air, water, light, sound and balance.',
  },
  {
    n: 6,
    title: 'Design, Test & Invent',
    fileId: '1has8bml2Bo-eDNlf6xeFl2XHXFLswy1d',
    pages: 107,
    projects: 20,
    blurb: 'Open challenges. Your child designs the thing, builds it, tests it and improves it.',
  },
]

export const firstBook = libraryBooks[0]

export const coverUrl = (fileId: string) =>
  `https://drive.google.com/thumbnail?id=${fileId}&sz=w800`

export const viewUrl = (fileId: string) => `https://drive.google.com/file/d/${fileId}/view`

export const downloadUrl = (fileId: string) =>
  `https://drive.google.com/uc?export=download&id=${fileId}`

export const bookLabel = (book: LibraryBook) =>
  `${String(book.n).padStart(2, '0')} ${book.title}`
